<template>
  <v-container>
    <div class="text-center" v-if="!formalitySchema">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <dynamic-form
      v-else
      ref="form"
      :options="{
        company: {exclude: true},
        statusLabels: {exclude: true},
        functionName: {exclude: true}
      }"
      :schema="formalitySchema"
      :value="item"
      @submit="submitForm($event)"
    />
  </v-container>
</template>

<script>
import DynamicForm from '@/components/DynamicForm.vue'
import { mapActions, mapGetters } from 'vuex'
import redaApp from '../api/redaApp'

export default {
  name: 'FormalityForm',
  props: {
    item: Object
  },
  components: {
    DynamicForm
  },
  data () {
    return {
      uid: this.item?.uid || null,
      loading: false,
      formalitySchema: null
    }
  },

  computed: {
    ...mapGetters('user', [
      'getUser'
    ]),
    ...mapGetters('company', [
      'getCompany'
    ])
  },
  methods: {
    async insertFormality (payload) {
      if (payload.company) payload.company = this.getCompany.identification
      if (this.uid) {
        return redaApp.update('formalities', payload, this.uid, true)
      }
      return redaApp.create('formalities', payload, true)
    },
    submitForm (formality) {
      this.loading = true
      this.insertFormality({ ...formality })
        .then(() => this.showSuccess('Trámite guardado'))
        .catch((e) => {
          console.error(e)
          this.showError('Error al guardar trámite')
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveForm () {
      if (this.$refs.form.validate()) {
        this.loading = true
        console.log('Form is valid and ready to save')
        console.log(this.formality)
        this.insertFormality({ ...this.formality })
          .then(() => this.showSuccess('Formality guardado'))
          .catch((e) => {
            console.error(e)
            this.showError('Error al guardar trámite')
          })
          .finally(() => {
            this.loading = false
          })
        // You can send `this.formality` as JSON via an API request
      }
    },
    ...mapActions('message', [
      'showSuccess',
      'showInfo',
      'showWarning',
      'showError'
    ])
  },
  watch: {
  },
  mounted: function () {
    redaApp.getDescribe('formalities').then((schema) => {
      this.formalitySchema = schema
    }).catch((e) => {
      console.error(e)
    })
  }
}
</script>
